import { useQuery } from "react-query"
import { queryKeys } from "../../client"
import api from "../../api"

const getData = async () => {
  const { data } = await api.get(`/warehouse-state`)
  return data.data
}

export const useWarehouseStates = () => {
  const { data, ...props } = useQuery(
    queryKeys.WAREHOUSE_STATES,
    () => getData(),
  )
  return { data, ...props }
}
